import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import InfiniteScroll from "react-infinite-scroll-component"
import { RequestPopUp } from "../../common/element/RequestPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IPageResponse } from "../../../types/IPageResponse"
import { IClientRequestDto } from "../../../types/request/IClientRequestDto"
import { useNavigate, useSearchParams } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useStore } from "../../../stores/RootStoreContext"
import { MenuManager } from "../MenuManager"
import { MenuAdmin } from "../../admin/MenuAdmin"
import { ManagerRequestListItem } from "./ManagerRequestListItem"
import { RequestStatus } from "../../../types/request/RequestStatus"
import { IRequestStatus } from "../../../types/request/IRequestStatus"
import { ICheckConversationResponse } from "../../../types/messenger/ICheckConversationResponse"
import { Messenger } from "../../common/messenger/Messenger"
import { IMG } from "../../common/CONST"
import { CONFIG } from "../../../CONFIG"
import Input from "@/ui/components/Input"
import Skeleton from "@/ui/components/Skeleton"
import Button from "@/ui/components/Button"
import EmptyRow from "@/ui/components/EmptyRow"
import { useUpdateEffect } from "react-use"
import { REQUEST_ROUTE } from "@/routes"
import { CurrencyRequestPopUp } from "@/components/common/element/CurrencyRequestPopUp"

enum RequestVariant {
  Ruble = "ruble",
  Currency = "currency"
}

export const ManagerRequestList = () => {
  const navigate = useNavigate()
  const { userStore } = useStore()
  const [searchParams] = useSearchParams()

  const [showRequestPopUp, setShowRequestPopUp] = useState(false)
  const [showCurrencyRequestPopUp, setShowCurrencyRequestPopUp] = useState(false)
  const [requestVariant, setRequestVariant] = useState<RequestVariant>(() =>
    searchParams.get("type") === RequestVariant.Currency ? RequestVariant.Currency : RequestVariant.Ruble
  )
  const [requestId, setRequestId] = useState<number | undefined>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [requestList, setRequestList] = useState<IPageResponse<IClientRequestDto>>()
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)
  const [isLoading, setLoading] = useState(true)
  const [isRefetchLoading, setRefetchLoading] = useState(false)

  const isCurrencyVariant = requestVariant === RequestVariant.Currency

  /* Messenger const */
  const [instanceId, setInstanceId] = useState<string>()
  const [conversationUserId, setConversationUserId] = useState<number>()
  const CHAT_INSTANCE = "REQUEST"
  const [unreadList, setUnreadList] = useState<IPageResponse<ICheckConversationResponse>>()

  const fetchUnread = () => {
    TrinityAPI.getUnreadConversations(CHAT_INSTANCE, response => {
      if (response.status === 200) {
        setUnreadList(response.data)
      }
    })
  }

  const fetchRequests = (isRefetch: boolean = false) => {
    TrinityAPI.getClientRequests(
      isRefetch ? CONFIG.defaultPage : page,
      searchParams.get("status") || "",
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 || isRefetch ? [] : requestList?.items || []
          setPage(page + 1)
          setRequestList({
            ...requestList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка загрузки запросов: " + response.data.message
          })
        }
      },
      () => {
        setLoading(false)
        isRefetch && setRefetchLoading(false)
      }
    )
  }

  const fetchCurrencyRequests = (isRefetch: boolean = false) => {
    TrinityAPI.getClientCurrencyRequests(
      isRefetch ? CONFIG.defaultPage : page,
      searchParams.get("status") || "",
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 || isRefetch ? [] : requestList?.items || []
          setPage(page + 1)
          setRequestList({
            ...requestList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка загрузки запросов: " + response.data.message
          })
        }
      },
      () => {
        setLoading(false)
        isRefetch && setRefetchLoading(false)
      }
    )
  }

  const refetchData = () => {
    setRefetchLoading(true)
    !isCurrencyVariant ? fetchRequests(true) : fetchCurrencyRequests(true)
  }

  const showModal = (id: number) => {
    const request = requestList?.items.filter(r => r.id === id)[0]
    if (!request) return

    setRequestId(id)
    isCurrencyVariant ? setShowCurrencyRequestPopUp(true) : setShowRequestPopUp(true)
  }

  const changeStatusFilter = (status: string) => {
    navigate(`${REQUEST_ROUTE}?status=${status}`)
  }

  const closeMessenger = () => {
    setInstanceId(undefined)
    setConversationUserId(undefined)
  }

  const showMessenger = (instanceId: string | undefined, userId: number | undefined) => {
    setInstanceId(instanceId)
    setConversationUserId(userId)
  }

  useEffect(() => {
    if (page === 0) {
      !isCurrencyVariant ? fetchRequests() : fetchCurrencyRequests()
    }
  }, [page])

  useUpdateEffect(() => {
    !isCurrencyVariant ? fetchRequests(true) : fetchCurrencyRequests(true)
  }, [searchParams, requestVariant, searchQuery])

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      {userStore.isManager ? <MenuManager active={"request"} /> : <MenuAdmin active={"request"} />}
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container">
          <ul className="nav-global-list">
            <li
              className={`nav-global-item${
                !searchParams.get("status") || searchParams.get("status") === "" ? "-active" : ""
              }`}
              onClick={() => navigate(REQUEST_ROUTE)}
            >
              Все
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "NEW" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=NEW`)}
            >
              Новые
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "APPROVED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=APPROVED`)}
            >
              Подтверждены
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "REJECTED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=REJECTED`)}
            >
              Отклонены
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "USED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=USED`)}
            >
              С пополнением
            </li>
          </ul>

          <h1 className="ui-heading">
            {searchParams.get("status") === "APPROVED"
              ? "Подтвержденные"
              : searchParams.get("status") === "REJECTED"
              ? "Отклоненные"
              : searchParams.get("status") === "NEW"
              ? "Новые"
              : searchParams.get("status") === "USED"
              ? "С пополнением"
              : "Все"}
          </h1>

          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.requests} alt="" className="header-chapter-img" />
              </div>
              <Button variant="black" loading={isRefetchLoading} onClick={refetchData}>
                Обновить список запросов
              </Button>
            </div>
          </section>

          <section className="search-block">
            <Input
              type="search"
              onChange={e => setSearchQuery(e.target.value)}
              placeholder="Название компании, имя клиента, ИНН, валюта или номер запроса"
            />
          </section>

          <div className="flex-row-24 justify-end">
            <Button
              variant={!isCurrencyVariant ? "black" : "grey"}
              onClick={() => setRequestVariant(RequestVariant.Ruble)}
            >
              Рублевые
            </Button>
            <Button
              variant={isCurrencyVariant ? "black" : "grey"}
              onClick={() => setRequestVariant(RequestVariant.Currency)}
            >
              Валютные
            </Button>
          </div>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item width-130">Запрос</li>
                <li className="header-global-item width-100">Сумма</li>
                <li className="header-global-item width-70">Валюта</li>
                <li className="header-global-item global-bank cols-request">Страна получателя</li>
                <li className="header-global-item global-bank cols-request">Страна банка</li>
                <li className="header-global-item cols-request">Клиент</li>
                {!isCurrencyVariant && <li className="header-global-item cols-request">ИНН</li>}
                <li className="header-global-item width-130">
                  <select
                    value={searchParams.get("status") || ""}
                    className="select-style"
                    onChange={e => changeStatusFilter(e.target.value)}
                  >
                    <option value="">Все</option>
                    <option value="NEW">Требуется действие</option>
                    {Object.keys(RequestStatus).map((key, index) => (
                      <option value={key} key={index}>
                        {RequestStatus[key as keyof IRequestStatus]}
                      </option>
                    ))}
                  </select>
                </li>
              </ul>
              <ul className="global-list">
                {isLoading ? (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                ) : (
                  <InfiniteScroll
                    scrollableTarget="scrollable"
                    next={fetchRequests}
                    hasMore={page < (requestList?.totalPages || 0)}
                    loader={<Skeleton gutterTop />}
                    dataLength={requestList?.items.length || 0}
                    className="message-list"
                    style={{ listStyleType: "none" }}
                  >
                    {(requestList?.items?.length || 0) > 0 ? (
                      requestList?.items.map((r, index) => (
                        <ManagerRequestListItem
                          request={r}
                          action={showModal}
                          isCurrencyVariant={isCurrencyVariant}
                          showMessenger={showMessenger}
                          unreadList={unreadList}
                          key={index}
                        />
                      ))
                    ) : (
                      <EmptyRow text="Запросов не найдено" />
                    )}
                  </InfiniteScroll>
                )}
              </ul>
            </section>
          </div>
        </div>
      </main>
      {showRequestPopUp && <RequestPopUp visible={showRequestPopUp} setVisible={setShowRequestPopUp} id={requestId} />}
      {showCurrencyRequestPopUp && (
        <CurrencyRequestPopUp
          visible={showCurrencyRequestPopUp}
          setVisible={setShowCurrencyRequestPopUp}
          id={requestId}
        />
      )}
      <Messenger instanceId={instanceId} type={CHAT_INSTANCE} userId={conversationUserId} close={closeMessenger} />
    </>
  )
}
